module.exports = __webpack_public_path__ + "img/order11.6f4707fc.svg";